import {
  forwardRef,
  type ChangeEventHandler,
  type FocusEventHandler,
} from "react";

import { InputContainer } from "../../../../common/input/styles/InputStyles";
import { SelectComponent, SelectLabel } from "../styles/NetworkSelect";

export type NetworkSelectOption = {
  label: string;
  value: string;
};

type SelectProps = {
  options: NetworkSelectOption[];
};

export type NetworkSelectProps = {
  label?: string;
  name: string;
  testId?: string;
  select?: SelectProps;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  maxLength?: number;
  isDisabled?: boolean;
  placeholder?: string;
};

export const NetworkSelect = forwardRef<HTMLInputElement, NetworkSelectProps>(
  (
    {
      label,
      name,
      testId,
      select,
      value,
      onBlur,
      onChange,
      maxLength,
      isDisabled = false,
      placeholder = "Selecione",
    },
    ref
  ) => {
    const inputId = testId ? `${testId}_select` : `${name}_select`;
    const options = select?.options ?? [];

    return (
      <InputContainer fullWidth>
        {label && (
          <SelectLabel className="input-label" htmlFor={inputId}>
            {label}
          </SelectLabel>
        )}

        <SelectComponent
          id={inputId}
          size="small"
          disabled={isDisabled}
          select
          slotProps={{
            select: {
              native: true,
            },
            htmlInput: {
              id: inputId,
              maxLength,
              "data-testid": testId,
            }
          }}
          inputRef={ref}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          variant="outlined"
        >
          <option value="" disabled>
            {placeholder}
          </option>

          {options.map((option) => (
            <option key={`option_${option.value}_${option.label}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </SelectComponent>
      </InputContainer>
    );
  }
);

NetworkSelect.displayName = "NetworkSelect";